<template>
	<div class="top_bar">
		<div class="container top_bar_box">
			<div class="top_bar_item top_bar_left">
				<div class="tagBtnList">
					<div class="tagBtn" @click="userClick('index')">回到首页</div>
					<!-- <div class="tagBtn">在线客服</div> -->
					<div class="tagBtn" @click="userClick('my')">个人中心</div>
					<div class="tagBtn" @click="userClick('order')">我的订单</div>
					<div class="tagBtn" @click="userClick('article', { id: '2' })">关于我们</div>
					<!-- <div class="tagBtn" @click="userClick('article', { id: '5' })">帮助中心</div> -->
					<div class="tagBtn" @click="userClick('article', { id: '19' })">消费者告知书</div>
				</div>
			</div>
			<div class="top_bar_item top_bar_right">
				<div v-if="! userInfo.token && ! wxUserInfo.token" class="tagBtnList">
					<p class="tagBtn">
						<router-link to='/login'>{{$t('common.log')}}</router-link>
					</p>
					<p class="tagBtn">
						<router-link to='/register'>{{$t('common.register')}}</router-link>
					</p>
				</div>
				<!-- <p v-if="userInfo"><router-link to='/my'>{{userInfo.shop_nickname}}</router-link></p> -->
				<div v-else class="tagBtnList">
					<el-dropdown
						class="tagBtn"
						@command="userClick"
						:trigger="documentWidth < 640 ? 'click' : 'hover' "
					>
						<span class="el-dropdown-link" style="line-height: 19px;">
							{{userInfo.shop_nickname}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="my">{{$t('common.pageHead.my')}}</el-dropdown-item>
							<el-dropdown-item command="order">{{$t('common.pageHead.order')}}</el-dropdown-item>
							<el-dropdown-item command="collect">{{$t('common.pageHead.collect')}}</el-dropdown-item>
							<el-dropdown-item command="address">{{$t('common.pageHead.address')}}</el-dropdown-item>
							<el-dropdown-item class="dropdown-logout" command="logout">{{$t('common.logout')}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<p class="tagBtn logout">
						<a style="cursor: pointer;margin-left: 10px;" @click="logout">{{$t('common.logout')}}</a>
					</p>
				</div>
				<!-- <p><router-link to='/register?isShop=1'>店铺入驻</router-link></p> -->
			</div>
		</div>
	</div>
</template>

<script>
	import { baseUrl } from '../../../config/index.js'
	import bus from '../../assets/bus'
	import { mapGetters } from 'vuex'
	export default {
		data() {
			const query = this.$router.currentRoute.query

			return {
				// 文档宽度
				documentWidth: document.body.clientWidth,
				goBack: query.goBack,

				dollar:{
					name:'U.S. Dollar',
					id:1
				},
				dollarArr:[{
					name:'U.S. Dollar',
					id:1
				},{
					name:'Australian Dollar ($)',
					id:2
				}],
			}
		},
		computed: {
			...mapGetters([
				// 'logo',
				'wxUserInfo',
				'userInfo',
			]),
			showNav() {
				// 超过这个数量的 nav 会放到下拉列表里
				return 4
			}
		},
		created(){
			this.$store.commit('setDeviceType')

			// 微信登录检测
			this.wxCheckLogin()

			// #全局监听
			// 前往商品详情页
			bus.$on('goProduct', args => {
				// args格式
				// {
				// 	path:"/productDetail",
				// 	query:{
				// 		id:id
				// 	}
				// }

				// console.log('goProduct =>', args)
				if(this.$store.state.deviceType === 'pc') {
					// url
					let url = args.path
					// url参数
					let urlParams = Object.entries(args.query)
					if(urlParams.length) {
						for(let i = 0; i < urlParams.length; i++) {
							urlParams[i] = urlParams[i].join('=')
						}
						url += '?' + urlParams.join('&')
					}

					// WARNING:
					// sessionStorage生命周期为标签页关闭——至少chrome浏览器是这样
					// 但window.open打开的新标签页会继承当前页的sessionStorage，
					// 之后新标签页的sessionStorage独立于原标签页运行

					// WARNING:
					// 页面初始化时，在router中 openPage的 生效优先级 比currentPage更高
					sessionStorage.setItem('openPage', url)

					// 在新标签页中打开当前域名根目录下的index文件，避免跳转到前端预渲染的页面去
					// window.open('/', '_blank')
					window.open(baseUrl, '_blank')

					// 打开新标签页后立即销毁openPage——避免当前标签页刷新后，路径变为最新的openPage的问题
					sessionStorage.removeItem('openPage')
				}
				// else if(this.$store.state.deviceType === 'phone') {
				else {
					this.$router.push(args)
				}
			})
		},
		destroyed() {
			bus.$off('goProduct')
		},
		methods:{
			// #wechat
			wxCheckLogin() {
				if(! this.userInfo.token) {
					const wxLogin = JSON.parse(sessionStorage.getItem('wxLogin'))
					sessionStorage.removeItem('wxLogin')

					if(wxLogin.code) {
						console.log('微信登录code =>', wxLogin)
						this.$store.commit('wxUserInfo', wxLogin)

						this.$showLoading()
						// WARNING: axios的get()的传参需要放置params里面，否则请求不会传参
						this.$server.get('https://apis.quxun.co/API/index.php/AppInterface/WechatLogin/get_weixin_pc_detail', {
							params: {
								code: this.wxUserInfo.code
							}
						})
						.then(res => {
							console.log('get_weixin_pc_detail =>', res)
							if(res.result === 1) {

								if(res.data) {
									this.$store.commit('setUserInfo', res.data.user_detail)
									this.$message.success(res.msg)

									// 更新购物车
									bus.$emit('carUpdate')

									// 返回上一页
									if(this.goBack) {
										this.$router.back()
									}
									else {
										this.$router.replace({
											path: "/"
										})
									}
								}
							}
							// res.code === 202
							else {
								this.$message.warning(res.msg)
							}
						})
						.catch(res => {
							console.log('err =>', res)
						})
						.finally(() => {
							this.$hideLoading()
						})
					}
				}
			},
			dollarClick(id){
				var index = this.dollarArr.findIndex( item => item.id == id)
				this.dollar=this.dollarArr[index]
			},
			userClick(type, opts){
				if(type === 'index') {
					this.$router.push("/")
				}
				else if(type=="my") {
					this.$router.push("/my")
				}
				else if(type=="order") {
					this.$router.push("/order")
				}
				else if(type=="collect") {
					this.$router.push("/collect")
				}
				else if(type === 'address') {
					this.$router.push("/address")
				}
				else if(type === 'article') {
					bus.$emit('goProduct', {
						path:"/article",
						query:{
							id: opts.id
						}
					})
				}
				else if(type === 'logout') {
					this.$store.commit('logout')
				}
			},
			goHome(){
				this.$router.push("/")
			},
			logout(){
				this.$confirm(this.$t('common.confirm-msg'), this.$t('common.tips'), {
					type: 'warning',
				})
				.then(() => {
					// bus.$emit('logout')
					this.$store.commit('logout')
					this.$message.success(this.$t('common.logout-msg'))
					this.$router.push({
						path: "/login",
					})
				})
				.catch(() => {});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.top_bar {
		$top_bar_Pad: 10px;
		// v-loading 的 mask 的 z-index 是2000，topbar要显示在mask的前面
		// z-index: 2001;
		// position: fixed;
		width: 100%;
		height: 40px;
		top: 0;
		left: 0;
		box-sizing: border-box;
		// padding: $top_bar_Pad;
		background-color: $defaultColor;
		border-bottom: 1px solid $defaultColor;
		color: #ffffff;
		font-size: 14px;

		.top_bar_box{
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-direction: row-reverse;
			// height: 20px;
			max-width: $container-MaxWidth;
			min-width: $container-MinWidth;
			margin: 0 auto;
			padding:20px 15rpx;

			.el-dropdown{
				cursor: pointer;
				color: #fff;
			}
			.top_bar_item{
				display: flex;
				align-items: center;

				.nav-item {
					width: 144px;
					color: #fff;
					text-align: center;
				}
				.logo {

				}
				.list-btn {
					display: none;
					white-space: nowrap;
				}

				.tagBtnList {
					display: flex;

					.tagBtn {
						position: relative;
						padding: $top_bar_Pad 0;
						cursor: pointer;

						// &:hover {
						// 	text-decoration: underline;
						// }
						a{
							color: #fff;
						}
					}
					.tagBtn + .tagBtn {
						// padding-left: 10px;
						margin-left: 19px;
					}
					.tagBtn + .tagBtn:before{
						content: '';
						display: block;
						position: absolute;
						top: $top_bar_Pad + 2px;
						left: -10px;
						width: 1px;
						height: 15px;
						background-color: #ffffff;
					}
				}
			}
			@media screen and (min-width: 992px) and (max-width: 1200px) {
				.top_bar_item {
					.nav-item {
						width: 120px;
						// background-color: greenyellow;
					}
				}
			}
			@media screen and (min-width: 768px) and (max-width: 991px) {
				.top_bar_item {
					.nav-item {
						width: 80px;
						// background-color: greenyellow;
					}
				}
			}
			@media screen and (min-width: 640px) and (max-width: 767px) {
				.top_bar_item {
					.nav-item {
						width: 80px;
						// background-color: greenyellow;
					}
				}
			}
			@media screen and (max-width: 639px) {
				.top_bar_item {
					.nav-item {
						width: 40%;
						display: none;
						// background-color: greenyellow;
					}
					.logo {
						display: flex;
					}
					.list-btn {
						display: flex;
					}
				}
			}
			$logo-width: 45px;
			.top_bar_left{
				display: flex;
				justify-content: start;

				img{
					width: $logo-width;
					height: $logo-width;
					object-fit: cover;
					border-radius: 5px;
					cursor: pointer;
				}
				span{
					color: #fff;
					font-size: 16px;
					margin-left: 10px;
				}
				a {
					display: flex;
					height: $logo-width;
					align-items: center;
					justify-content: center;
				}
			}
			.top_bar_right{
				white-space: nowrap;

				.logout {

				}
				@media screen and (max-width: 767px) {
					.logout {
						display: none;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Common/Topbar.vue